/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    index: "1",
    note: "",
    isSave: false,
    title: "Thông tin về người nộp thuế:",
  },
  {
    id: uuidV4(),
    index: "1.1",
    isSave: false,
    note: "",
    title:
      "Thông tin cơ cấu quản lý và tổ chức, bao gồm sơ đồ tổ chức, danh sách, thông tin tóm lược các chức danh quản lý của tập đoàn mà người nộp thuế phải báo cáo trực tiếp và địa chi văn phòng, trụ sở chính của các chức danh này",
  },
  {
    id: uuidV4(),
    index: "1.2",
    isSave: false,
    note: "",
    title:
      "Thông tin chi tiết về hoạt động kinh doanh, chiến lược kinh doanh của người nộp thuế, bao gồm thông tin về việc người nộp thuế có tham gia hoặc chịu tác động vào quá trình, quyết định tái cơ cấu hay chuyển nhượng vốn, chuyển nhượng tài sản của tập đoàn trong năm kê khai",
  },
  {
    id: uuidV4(),
    index: "1.3",
    isSave: false,
    note: "",
    title:
      "Thông tin các doanh nghiệp có các sản phẩm, dịch vụ tương đồng trên thị trưởng trong nước và quốc tế (các đối thủ cạnh tranh chính):",
  },
  {
    id: uuidV4(),
    index: "2",
    isSave: false,
    note: "",
    title:
      "Các giao dịch liên kết: với mỗi loại/dòng giao dịch liên kết trọng yếu mà người nộp thuế có liên quan, cung cấp các thông tin sau:",
  },
  {
    id: uuidV4(),
    index: "2.1",
    isSave: false,
    note: "",
    title:
      "Mô tả về các giao dịch liên kết trọng yếu (ví dụ cung cấp dịch vụ sản xuất, mua 2.1 hàng hóa, cung cấp dịch vụ, khoản vay, các bảo lãnh thực hiện và tài chính, nhượng quyền TSVH, v.v...) và bối cảnh mà các giao dịch này được thực hiện",
  },
  {
    id: uuidV4(),
    index: "2.2",
    isSave: false,
    note: "",
    title:
      "Giá trị và hóa đơn các khoản thanh toán và được thanh toán trong nội bộ tập đoàn đối với mỗi loại giao dịch liên quan đến công ty con (ví dụ thanh toán và được trả đối với sản phẩm, dịch vụ, bản quyền, lỗi vay, v.v...) bị Cơ quan thuế nước ngoài điều chỉnh",
  },
  {
    id: uuidV4(),
    index: "2.3",
    isSave: false,
    note: "",
    title:
      "Xác định các bên liên kết liên quan đến các giao dịch liên kết và quan hệ giữa các bên liên kết này",
  },
  {
    id: uuidV4(),
    index: "2.4",
    isSave: false,
    note: "",
    title: "Bản sao các thỏa thuận, hợp đồng giao dịch liên kết",
  },
  {
    id: uuidV4(),
    index: "2.5",
    isSave: false,
    note: "",
    title:
      "Phân tích chức năng và phân tích so sánh chi tiết đối với người nộp thuế và các bên liên kết đối với mỗi loại giao dịch liên kết, bao gồm bất kỳ thay đổi nào so với năm trước đó.",
  },
  {
    id: uuidV4(),
    index: "2.6",
    isSave: false,
    note: "",
    title:
      "Thuyết minh phương pháp xác định giá phù hợp nhất liên quan đến các dòng giao dịch liên kết và lý do lựa chọn phương pháp xác định giá đề xuất",
  },
  {
    id: uuidV4(),
    index: "2.7",
    isSave: false,
    note: "",
    title:
      "Xác định bên liên kết được lựa chọn xác định giá giao dịch liên kết, và giải trình lý do lựa chọn",
  },
  {
    id: uuidV4(),
    index: "2.8",
    isSave: false,
    note: "",
    title: "Tóm tắt các giả định trọng yếu khi áp dụng phương pháp xác định giá đề xuất",
  },
  {
    id: uuidV4(),
    index: "2.9",
    isSave: false,
    note: "",
    title: "Giải trình các lý do thực hiện phân tích dữ liệu nhiều năm (nếu có)",
  },
  {
    id: uuidV4(),
    index: "2.10",
    isSave: false,
    note: "",
    title:
      "Danh mục và mô tả các đối tượng so sánh độc lập (đối tượng nội bộ và đối tượng bên ngoài) và thông tin, chi số tài chính cần thiết phục vụ phân tích giá chuyển nhượng, bao gồm mô tả về phương pháp tìm kiếm dữ liệu so sánh và nguồn thông tin tìm kiếm",
  },
  {
    id: uuidV4(),
    index: "2.11",
    isSave: false,
    note: "",
    title: "Mô tả các khoản điều chỉnh so sánh đã thực hiện, lý do, tài liệu về kết quả điều chỉnh",
  },
  {
    id: uuidV4(),
    index: "2.12",
    isSave: false,
    note: "",
    title:
      "Mô tả lý do và diễn giải việc áp dụng phương pháp xác định giá đề xuất đã tuân thủ nguyên tắc giao dịch độc lập",
  },
  {
    id: uuidV4(),
    index: "2.13",
    isSave: false,
    note: "",
    title:
      "Tóm tắt thông tin về các chỉ số, chỉ tiêu, tiêu chí tài chính định lượng và lý do, diễn giải về việc các chi tiêu này được sử dụng trong quá trình áp dụng phương pháp xác định giá đề xuất",
  },
  {
    id: uuidV4(),
    index: "2.14",
    isSave: false,
    note: "",
    title:
      "Bản sao các Thỏa thuận APA đơn phương và song phương, đa phương và các thỏa thuận khác về thuế liên quan đến các giao dịch liên kết của người nộp thuế mà Cơ quan thuế Việt Nam không phải là một bên tham gia thỏa thuận, ký kết",
  },
  {
    id: uuidV4(),
    index: "3",
    isSave: false,
    note: "",
    title: "Thông tin tài chính:",
  },
  {
    id: uuidV4(),
    index: "3.1",
    isSave: false,
    note: "",
    title: "Báo cáo tài chính của năm kê khai của người nộp thuế",
  },
  {
    id: uuidV4(),
    index: "3.2",
    isSave: false,
    note: "",
    title:
      "Thông tin và kế hoạch phân bổ và cách thức sử dụng các dữ liệu tài chính khi áp dụng phương pháp xác định giá đề xuất",
  },
  {
    id: uuidV4(),
    index: "3.3",
    isSave: false,
    note: "",
    title:
      "Mô tả tóm tắt về các dữ liệu tài chính có liên quan trong quá trình phân tích so sánh và nguồn dữ liệu",
  },
  {
    id: uuidV4(),
    index: "3.4",
    isSave: false,
    note: "",
    title:
      "Tóm tắt lý do và giải trình nguyên nhân, kế hoạch kinh doanh, đầu tư và chiến lược phát triển đối với các doanh nghiệp có kết quả kinh doanh thua lỗ từ 03 năm trở lên",
  },
];

export default function CorporateIncomeTaxTable18({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => ["1", "2", "3"].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex">
        <Typography variant="h5">
          Công ty báo cáo các thông tin, tài liệu đã chuẩn bị và lưu trữ theo quy định tại phụ lục
          II, như sau:
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tài liệu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đã nhập và lưu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ghi chú
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    maxWidth: 500,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    maxWidth: 100,
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <Switch
                      checked={item.isSave}
                      onChange={({ target: { checked } }) =>
                        handleChange({ id: item.id, value: checked, name: "isSave" })
                      }
                    />
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      value={item.note}
                      name="note"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
